const suits = ["hearts", "diamonds", "clubs", "spades"];

const details = [
  {
    name: "Two",
    value: 2,
    card: "2",
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Three",
    value: 3,
    card: "3",
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Four",
    value: 4,
    card: "4",
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Five",
    value: 5,
    card: "5",
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Six",
    value: 6,
    card: "6",
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Seven",
    value: 7,
    card: "7",
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Eight",
    value: 8,
    card: "8",
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Nine",
    value: 9,
    card: "9",
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Ten",
    value: 10,
    card: "10",
    gamePoints: 10,
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Jack",
    value: 11,
    card: "J",
    gamePoints: 1,
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Queen",
    value: 12,
    card: "Q",
    gamePoints: 2,
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "King",
    value: 13,
    card: "K",
    gamePoints: 3,
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
  {
    name: "Ace",
    value: 14,
    card: "A",
    gamePoints: 4,
    trump: false,
    faceUp: false,
    user: false,
    owner: "",
  },
];

const deck = [];
for (let suit of suits) {
  for (let detail of details) {
    deck.push({
      suit,
      shouldDarken: false,
      details: {
        ...detail,
        card: `${detail.card}${suit[0].toUpperCase()}`,
        url: `/cards/${detail.card}${suit[0].toUpperCase()}.svg`,
      },
    });
  }
}

export default deck;
